import { gql } from '@apollo/client';

export const UPDATE_CALMET_WITH_WRF_CONFIGURATION = gql`
    mutation updateCalmetWithWrfConfiguration($id: ID!, $input: UpdateCalmetWithWrfPatch!) {
        facility {
            modelConfigurations {
                calmetConfigurations {
                    updateCalmetWithWrf(id: $id, input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
